export const packer_gauge_options = [
  { label: "Drobne", value: "small" },
  { label: "Gabaryty", value: "big" },
];

export default packer_gauge_options;
